<template>
<div class="block" v-loading.fullscreen.lock="loading">
    <subHeader :title="service.title" :subtitle="service.description" :img_header="service.img"></subHeader>

    <div class="container ptb-100 px-4" style="margin-top:50px;">
        <div class="row">
            <div class="col-sm-3 d-none d-md-block">
                <steps :step="step_current" :steps="steps_collection"></steps>
            </div>
            <div class="col-sm-5">
                <ClubPark v-if="step_current == 0" :listSeats="listSeats" @resClub="resClub"></ClubPark>

                <Plantita v-if="step_current == 1" :club="seat" @resPlanta="resPlanta"></Plantita>

                <Facturacion v-if="step_current == 2" :abonado="{}" @resFact="resFact" @resVolver="resVolver"></Facturacion>

            </div>
            <div class="col-sm-4">
                <Resumen :items="carrito"></Resumen>

            </div>
        </div>
    </div>

</div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader";
import steps from "@/components/common/Steps";
import ClubPark from "@/components/common/ClubPark";
import Plantita from "./Producto"
import Facturacion from "@/components/pages/abonados/Facturacion";
import Resumen from "./Resumen"

//services
import services from "@/services/services.service";
import moment from "moment";
import { mapGetters } from 'vuex'

export default {
    components: {
        subHeader,
        steps,
        ClubPark,
        Plantita,
        Facturacion,
        Resumen
    },
    data: () => ({
        loading: false,
        service: {},
        step_current: 0,
        steps_collection: [],
        listSeats: [],
        seat: {},
        carrito: [],
        form: {}
    }),
    computed: {
      ...mapGetters(['totalPagar'])
    },
    created() {
        this.$store.dispatch("updateSubRouter", true);
    },
    mounted() {
        this.init();
    },
    methods: {
        showError(message) {
            this.$alert(message, "Aviso", {
                confirmButtonText: "Entendido",
                type: "warning",
                center: true,
            });
        },
        async init() {
            this.loading = true;
            this.steps_collection = [];
            await services
                .get("plantas-vivero")
                .then((res) => {
                    this.service = res.data.details;
                    this.steps_collection = JSON.parse(res.data.details.steps);

                    axios
                        .post(`${process.env.API2}/v1/planta/listarCategoriaPlanta/3`)
                        .then((res) => {
                            //console.log(res.data)
                            if (res.data.length > 0) {
                                const tmp = res.data.map((item) => {
                                    return {
                                        idseat: item.value,
                                        name: item.detalle,
                                        city: 'Villa el salvador',
                                        address: null,
                                        latitud: null,
                                        longitud: null,
                                    };
                                });
                                this.listSeats = tmp;
                            }
                            //console.log(this.listSeats);
                        });
                })
                .catch((err) => {
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resClub(club) {
            this.seat = club;
            this.step_current++;
        },

        resPlanta(data) {
            this.carrito = data;
            this.step_current++;
            //console.log(data)
        },

        saveVentaSPV() {
            this.loading = true
            axios
                .post(`${process.env.API2}/v1/planta/registrarPlanta`, {
                    cabeceraParameter: {
                        ue: "001066",
                        sede: "001",
                        codigoVenta: "",
                        fechaEmision: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
                        tipoSistema: "ART",
                        areaId: "00027",
                        tipoDocumentoId: this.form.st2.voucher,
                        docNumero: this.form.st2.fndoc,
                        nombre: this.form.st2.fname,
                        total: this.totalPagar
                    },
                    cuerpoParameters: this.carrito
                })
                .then((res) => {
                    //this.loading = false;
                    if (parseInt(res.data) > 0) {
                        this.form.operation = parseInt(res.data);
                        axios
                            .post(`${process.env.API1}/api/plantitas/register`, this.form)
                            .then((response) => {
                                this.loading = false;
                                if (response.data.status)
                                    window.location.href = response.data.url;
                                else alert(response.data.message);
                            })
                            .catch((err) => {
                                this.loading = false;
                            });

                    } else {
                        this.loading = false;
                        this.showError("Lo sentimos, no se ha podido registrar la información.");
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        resFact(data) {

            this.$confirm('Está a punto de ir con el proceso de pago, desea continuar?', 'info', {
                confirmButtonText: 'si, continuar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                this.form.st0 = this.seat;
                this.form.st1 = this.carrito;
                this.form.st2 = data
                this.saveVentaSPV()
            }).catch(() => {});
        },

        resVolver(step){
          this.step_current = step-1;
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/plantitas/Index.vue